import { render, staticRenderFns } from "./related-tag.component.vue?vue&type=template&id=b6b788a0&scoped=true"
import script from "./related-tag.component.vue?vue&type=script&lang=ts"
export * from "./related-tag.component.vue?vue&type=script&lang=ts"
import style0 from "./related-tag.component.vue?vue&type=style&index=0&id=b6b788a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b788a0",
  null
  
)

export default component.exports